
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/24b2f48a9432c7dc20836040248412fa.jpg')`
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-4xl mx-auto text-center text-white">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Transformamos Tu Negocio con 
            <span className="text-blue-400"> Estrategia</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto">
            Consultoría estratégica personalizada que impulsa el crecimiento empresarial. 
            Desde análisis fundamental hasta transformación completa de tu organización.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => scrollToSection('servicios')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              <i className="ri-rocket-line mr-2"></i>
              Ver Nuestros Servicios
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => scrollToSection('contacto')}
              className="border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-phone-line mr-2"></i>
              Consulta Gratuita
            </Button>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/20">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-400 mb-2">500+</div>
              <div className="text-gray-300">Empresas Transformadas</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-400 mb-2">15+</div>
              <div className="text-gray-300">Años de Experiencia</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-400 mb-2">98%</div>
              <div className="text-gray-300">Satisfacción del Cliente</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
